import { StudentAv } from "./student-availability-model";
import { StudentInternShipKeyDetails } from "./student-internship-key-details-model";

export class studentInternshipDataModel{
    studentInternshipTitle:string;
    studentInternshipSubTitle:any = [new StudentAv(),new InternshiDetails()];
    studentFeedback: any =[]
    mentorFeedBack:any = []

}

export class InternshiDetails{
    subtitle ='Internship Details';
    showLabels=['Available for internship?','Internship Title','Status','Internship Start date','Internship end date','Company Name','Location','Address','Project Name','Mentor Name','Guide Name','Mentor E-Mail','Guide E-Mail','Mentor phone','Guide Phone','HR Name','Accomodation Contact Person','HR E-Mail','Accomodation Address','HR Phone']
    keyLabels= ['isInternshipAssigned','internshipTitle','internshipStatusByMentor','internshipStartDate','internshipEndDate','companyName','locName','locAddress','internshipProjectName','mentorName','guideName','mentorEmail','guideEmail','mentorMobile','guideMobile','hrName','accommodationContactPerson','hrEmail','accommodationAddress','hrMobile','isInternshipCertyVerified']
    keyDetails:StudentInternShipKeyDetails[] = []
}


